// extracted by mini-css-extract-plugin
export default {"link":"SiteNavigationItem_link__kzdoN","active":"SiteNavigationItem_active__DORDk"};